import { render } from "./Blog.vue?vue&type=template&id=32d122d2&scoped=true&ts=true"
import script from "./Blog.vue?vue&type=script&lang=ts"
export * from "./Blog.vue?vue&type=script&lang=ts"

import "./Blog.vue?vue&type=style&index=0&id=32d122d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d122d2"]])

export default __exports__